import jwt from "jsonwebtoken";
export const signToken = (token, config) => {
  const secretKey = config.BROKER_SECRET_KEY;
  const broker = config.BROKER_NAME;
  const payloadSign = {
    broker: broker,
    token,
    iat: new Date().getTime() / 1000,
  };
  const signedToken = jwt.sign(payloadSign, secretKey, {
    algorithm: "HS256",
  });
  return signedToken;
};


